import { nt_diem_danh_trang_thai } from "../models/response/category/nt_diem_danh_trang_thai";
import { BaseCRUDApi } from "./baseCRUDApi";

export const API_DIEMDANH_STATUS_PATH = "diem-danh-status"

class DiemDanhStatusApi extends BaseCRUDApi<nt_diem_danh_trang_thai> {
    constructor({ path }: { path: string; }) {
        super(path);
    }
}
export const diemDanhStatusApi = new DiemDanhStatusApi({ path: API_DIEMDANH_STATUS_PATH });